/**
 * Qovo — Inline Notify Me (coming-soon section cards)
 * Handles the per-card email forms marked [data-inline-notify] in
 * sections/coming-soon.liquid. Posts straight to the Worker's
 * /qovo/oos/subscribe endpoint — that endpoint is intentionally public
 * (no auth header required; only /oos/admin/* needs one).
 * No dependencies. Deferred. ~2 KB.
 */
(function () {
  'use strict';

  var BASE = 'https://keplin-mcp.mo-3e5.workers.dev';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function setMessage(el, text, state) {
    if (!el) return;
    el.textContent = text || '';
    if (state) {
      el.setAttribute('data-state', state);
    } else {
      el.removeAttribute('data-state');
    }
  }

  function handleSubmit(form) {
    var emailEl   = form.querySelector('[data-inline-notify-email]');
    var submitEl  = form.querySelector('[data-inline-notify-submit]');
    var messageEl = form.querySelector('[data-inline-notify-message]');

    var email = (emailEl && emailEl.value.trim()) || '';
    if (!email || !EMAIL_RE.test(email)) {
      setMessage(messageEl, 'Please enter a valid email address.', 'error');
      return;
    }

    var productId    = form.dataset.productId    || '';
    var variantId     = form.dataset.variantId     || '';
    var productTitle  = form.dataset.productTitle  || '';
    var variantTitle  = form.dataset.variantTitle  || '';
    var productHandle = form.dataset.productHandle || '';

    // Single-variant products render "Default Title" — normalise to the
    // product title so the Worker's required variant_title stays meaningful.
    if (!variantTitle || variantTitle === 'Default Title') {
      variantTitle = productTitle;
    }

    if (!productId || !variantId) {
      setMessage(messageEl, 'This item is not set up for notifications yet.', 'error');
      return;
    }

    var originalLabel = submitEl ? submitEl.textContent : '';
    if (submitEl) { submitEl.disabled = true; submitEl.textContent = 'Sending…'; }
    setMessage(messageEl, '');

    var payload = {
      email:          email,
      product_id:     productId,
      variant_id:     variantId,
      product_title:  productTitle,
      variant_title:  variantTitle,
      product_handle: productHandle
    };

    fetch(BASE + '/qovo/oos/subscribe', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload)
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
      .then(function (r) {
        if (r.ok && (r.data.status === 'subscribed' || r.data.status === 'already_subscribed')) {
          var msg = r.data.status === 'already_subscribed'
            ? "You're already on the list for this item."
            : "You’re on the list! We’ll email you when it’s back.";
          setMessage(messageEl, msg, r.data.status === 'already_subscribed' ? 'already' : 'success');
          if (emailEl)  emailEl.value = '';
          if (submitEl) submitEl.textContent = 'Notified';
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event:               'notify_me_signup',
            product_title:       productTitle,
            product_id:          productId,
            variant_id:          variantId,
            product_handle:      productHandle,
            subscription_status: r.data.status
          });
        } else {
          var errMsg = (r.data && r.data.error) || 'Something went wrong. Please try again.';
          setMessage(messageEl, errMsg, 'error');
          if (submitEl) { submitEl.disabled = false; submitEl.textContent = originalLabel; }
        }
      })
      .catch(function () {
        setMessage(messageEl, 'Network error. Please try again.', 'error');
        if (submitEl) { submitEl.disabled = false; submitEl.textContent = originalLabel; }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-inline-notify]')) return;
    e.preventDefault();
    handleSubmit(form);
  });
})();
